import { useState, useEffect } from 'react'
import { kernel } from '@omni/kernel'
import { navigate } from '../shell/router'
import { Slot } from '@omni/kernel/slot'
import { ArrowLeft } from '@omni/icon-kit'

export function SettingsPage() {
  const [contributions, setContributions] = useState([])

  // subscribe(name, cb) only SIGNALS a change - it calls cb with no
  // arguments. The list itself always has to be re-read from the registry,
  // or a plugin that registers its panel AFTER this page has mounted (ai-core
  // does, it awaits initSettings first) sets contributions to undefined and
  // crashes the render on the next line's .length.
  useEffect(() => {
    const read = () => setContributions(kernel.slots.getContributions('settings'))
    const d = kernel.slots.subscribe('settings', read)
    read()
    return () => d.dispose()
  }, [])

  return (
    <div className="bg-base-200 min-h-full">
      <div className="navbar bg-base-100 shadow">
        <button data-test="board-nav" className="btn btn-ghost" onClick={() => navigate('/')}>
          <ArrowLeft size={16} /> Board
        </button>
        <span className="text-lg font-semibold">Settings</span>
      </div>
      <div className="mx-auto max-w-2xl p-4 flex flex-col gap-6">
        {contributions.length === 0 ? (
          <p className="text-base-content/60 text-center">No settings panels are installed.</p>
        ) : (
          <Slot name="settings" registry={kernel.slots} className="flex flex-col gap-6" />
        )}
      </div>
    </div>
  )
}